export default function Toast({ message, type = "success", onClose }) {
  return (
    <div
      className={`fixed bottom-4 sm:bottom-6 left-4 right-4 sm:left-auto sm:right-6 z-50 px-4 sm:px-5 py-2.5 sm:py-3 rounded-lg sm:rounded-xl shadow-lg text-xs sm:text-sm max-w-full sm:max-w-md
        ${type === "success"
          ? "bg-green-600 text-white"
          : "bg-red-600 text-white"}
      `}
    >
      <div className="flex items-center justify-between gap-3 sm:gap-4">
        <span className="flex-1 min-w-0 truncate">{message}</span>
        <button
          onClick={onClose}
          className="text-white font-bold text-lg hover:opacity-80 transition-opacity flex-shrink-0"
        >
          ×
        </button>
      </div>
    </div>
  );
}

